import { useNavigate, useSearchParams } from 'react-router';

import { useRouteTracker } from '@/caregiverSpace/shared/model';

export const useNavigation = () => {
    const navigate = useNavigate();
    const { history, popFromHistory } = useRouteTracker();
    const [searchParams, setSearchParams] = useSearchParams();

    const goBack = () => {
        popFromHistory();
    };

    const goToPage = (path: string) => {
        navigate(path);
    };

    const getPatientPagePath = (id: number) => `/profile/patient/${id}`;

    const goToPatientPage = (id: number) => {
        navigate(getPatientPagePath(id));
    };

    const openPatientPageInNewTab = (id: number) => {
        const path = '/caregiver/caregiverspace' + getPatientPagePath(id);
        window.open(path, '_blank');
    };

    const goToPetPage = (id: number): void | Promise<void> => {
        navigate(`/profile/pet/${id}`);
    };

    const goToProfileConsultation = (
        patientId: number,
        consultationId: number | string,
    ): void | Promise<void> => {
        navigate(
            `/profile/patient/${patientId}?consultationUid=${consultationId}`,
        );
    };

    const goToPetConsultation = (
        petId: number,
        consultationId: number | string,
    ): void | Promise<void> => {
        navigate(`/profile/pet/${petId}?consultationUid=${consultationId}`);
    };
    const getPreviousPageName = () => {
        if (history.length < 2) {
            return null;
        }
        return history[history.length - 2].pageTitle;
    };

    const getConsultationId = () => {
        const consultationUidFromParams = searchParams.get('consultationUid');
        if (consultationUidFromParams) {
            return consultationUidFromParams;
        }
    };

    const goToWaitingRoom = () => {
        navigate('/');
    };

    const goToPatientsPage = () => {
        navigate('/patients');
    };

    const setConsultationIdInUrl = (consultationId: string | number) => {
        searchParams.set('consultationUid', consultationId.toString());
        setSearchParams(searchParams, { replace: true });
    };

    const removeConsultationIdFromUrl = () => {
        searchParams.delete('consultationUid');
        setSearchParams(searchParams, { replace: true });
    };

    const handleConsultationRowToggle = (
        rowId: string | number,
        isExpanded: boolean,
    ) => {
        if (isExpanded) {
            setConsultationIdInUrl(rowId);
        } else {
            removeConsultationIdFromUrl();
        }
    };

    return {
        goBack,
        goToPage,
        getPreviousPageName,
        goToPatientPage,
        openPatientPageInNewTab,
        goToPetPage,
        getConsultationId,
        goToProfileConsultation,
        goToPetConsultation,
        handleConsultationRowToggle,
        goToWaitingRoom,
        goToPatientsPage,
    };
};
